import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import MarketAppResource from "./MarketAppResource";
import OrganizationAppResource from "./OrganizationAppResource";

export const EVERY_HOUR = '0 * * * *';
export const EVERY_2_HOURS = '0 */2 * * *';
export const EVERY_4_HOURS = '0 */4 * * *';
export const EVERY_DAY = '0 0 * * *';
export const EVERY_WEEK = '0 0 * * 0';
export const NEVER = null;

export const SCHEDULE_OPTIONS = [
    {
        label: 'Every hour',
        value: EVERY_HOUR,
    },
    {
        label: 'Every 2 hours',
        value: EVERY_2_HOURS,
    },
    {
        label: 'Every 4 hours',
        value: EVERY_4_HOURS,
    },
    {
        label: 'Every day',
        value: EVERY_DAY,
    },
    {
        label: 'Every week',
        value: EVERY_WEEK,
    },
    {
        label: 'Off',
        value: NEVER,
    },
];

class MLSAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'MLS';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'mls';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'abbreviation',
            'name',
            'lexicon',
            'compliance',
            'metadata',
            'marketUuid',
            'market',
            'licensed',
            'schedule',
            'exported',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            market: MarketAppResource,
            organizations: OrganizationAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            market: 'market_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            abbreviation: {
                type: 'string',
                presence: true,
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            name: {
                type: 'string',
                presence: true,
                length: {
                    minimum: 1,
                    maximum: 255,
                },
            },
            licensed: {
                type: 'boolean',
            },
            schedule: {
                type: 'string',
            },
            exported: {
                type: 'boolean',
            }
        };
    }

}

export default MLSAppResource;
